import React, { useCallback } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface LoanPurposeInputProps {
  value?: Record<string, any>;
  onChange?: (data: Record<string, any>) => void;
  disabled?: boolean;
}

const LoanPurposeInput: React.FC<LoanPurposeInputProps> = ({
  value = {},
  onChange,
  disabled = false,
}) => {
  const currentValue = value?.loan_purpose ?? '';

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.({ loan_purpose: e.target.value });
  }, [onChange]);

  return (
    <div className="space-y-1.5">
      <Label htmlFor="loan_purpose" className="text-sm font-medium text-gray-700">
        Purpose of Loan
      </Label>
      <Input
        id="loan_purpose"
        type="text"
        value={currentValue}
        onChange={handleChange}
        disabled={disabled}
        placeholder="e.g. Business expansion"
        className="mt-1"
      />
    </div>
  );
};

export default LoanPurposeInput;
